<template>
  <div class="result">
    <img v-if="s == 1" src="@/assets/images/succ.png" alt="" />
    <img v-if="s == 2" src="@/assets/images/succ2.png" alt="" />
    <div v-if="s == 1" class="tg">核验通过</div>
    <div v-if="s == 2" class="tg">核验失败</div>
    <div class="item">
      <p v-if="s == 1">比对结果一致，区块链标识校验通过， 数据未被篡改</p>
      <p v-if="s == 2">比对结果不一致，数据可能被篡改</p>
    </div>
    <div class="footer">
      <div class="footer-content" @click="$router.back()">返回</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      s: "",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    //
    this.s = this.$route.query.s;
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {},
};
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}
.result {
  height: 100vh;

  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .tg {
    margin-top: 32px;
    font-size: 40px;
    font-weight: bold;
  }
  img {
    margin-top: 140px;
    width: 160px;
    height: 160px;
  }

  .item {
    margin-top: 60px;
    text-align: center;
    width: 542px;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 48px;
    color: #222222;
  }

  .footer {
    width: 488px;
    height: 90px;
    background: #ffffff;
    border-radius: 8px;
    border: 2px solid #00644c;
    margin: 180px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      color: #00644c;
      font-size: 32px;
    }
  }
}
</style>
